import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Stack } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Interface, InterfaceProperty } from "../../types/Interface";
import { ProductInterface } from "../../types/ProductInterface";
import { WorkshopProductCombination } from "../../types/WorkshopProductCombination";
import { WorkshopProduct } from "../../types/WorkshopProducts";
import { GroupAccordion } from "./GroupAccordion";
import { InputCompletionChip } from "./InputCompletionChip";
import { FolderLabel } from '../../subs/FolderLabel';

export interface InterfacesToProperties {
    iface: Interface,
    properties: InterfaceProperty[]
}

export const InterfaceAccordion = ({ workshopProduct, workshopProductCombination, interfaceToProperties, productInterfaces, disabled }:
    {
        interfaceToProperties: InterfacesToProperties[], workshopProductCombination: WorkshopProductCombination,
        disabled?: boolean, productInterfaces: ProductInterface[], workshopProduct: WorkshopProduct
    }) => {
    const [propertiesComplete, setPropertiesComplete] = React.useState<number>(0);
    const [propertiesIncomplete, setPropertiesIncomplete] = React.useState<number>(0);
    const [propertiesOptional, setPropertiesOptional] = React.useState<number>(0);
    const [propertiesAllComplete, setPropertiesAllComplete] = React.useState<boolean>(false);

    return <>{interfaceToProperties.map(itp => productInterfaces.find(pi => pi.interfaceId === itp.iface.id && pi.supportedByProduct) &&
        itp && itp.iface && itp.properties && itp.properties.length > 0 &&
    <Accordion key={itp.iface.id} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Stack width={'100%'} direction={'row'} justifyContent={'space-between'}>
                {<FolderLabel labelText={(disabled ? 'Server Properties: ' : '') + itp.iface.name} labelVariant='large' noicon={true}
                        passed={disabled ? 0 : propertiesComplete} info={disabled ? 0 : propertiesOptional} errors={disabled ? 0 : propertiesIncomplete} />}
                {!disabled && <InputCompletionChip completed={propertiesAllComplete} />}
            </Stack>
        </AccordionSummary>

        <AccordionDetails>
                <GroupAccordion interfaceProperties={itp.properties} disabled={disabled} workshopProduct={workshopProduct} workshopProductCombination={workshopProductCombination}
                    setPropertiesOptional={setPropertiesOptional}
                setPropertiesComplete={setPropertiesComplete} setPropertiesIncomplete={setPropertiesIncomplete} setPropertiesAllComplete={setPropertiesAllComplete}/>
        </AccordionDetails>
    </Accordion>)}</>
}